import style from "./TableWrapper.module.scss";

export function TableWrapper({
    children
}: {
    children: [JSX.Element, JSX.Element]
}) {
    return (
        <div className={style.table}>
            {children} 
        </div>
    )
}